import type { Action } from 'svelte/action';

/**
 * Adds 'in-view' class when element scrolls into viewport.
 * Usage: <div use:reveal class="reveal">...</div>
 */
export const reveal: Action<HTMLElement> = (node) => {
    if (typeof IntersectionObserver === 'undefined') {
        node.classList.add('in-view');
        return;
    }

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    node.classList.add('in-view');
                    observer.unobserve(node);
                }
            });
        },
        { threshold: 0.12, rootMargin: '0px 0px -50px 0px' }
    );

    observer.observe(node);

    return {
        destroy() {
            observer.disconnect();
        }
    };
};
